var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';
import { connect } from 'react-redux';
import { getDataURL } from '../selectors';

var Transparencia = function Transparencia(_ref) {
  var dataURL = _ref.dataURL,
      style = _ref.style;

  if (!dataURL) {
    return false;
  }

  var pizarraStyle = _extends({
    backgroundImage: 'url(' + dataURL + ')',
    // backgroundSize: 'contain',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    pointerEvents: 'none'
  }, style);

  return React.createElement('div', {
    className: 'transparencia',
    style: pizarraStyle
  });
};

Transparencia.propTypes = process.env.NODE_ENV !== "production" ? {
  dataURL: t.string,
  style: t.object
} : {};
Transparencia = connect(function (state, ownProps) {
  return {
    dataURL: getDataURL(state)
  };
})(Transparencia);
export default Transparencia;